export default function() {
  const $gallery = document.querySelector('.js-gallery');
  const $items = document.querySelectorAll('.js-gallery-item');
  const $counter = document.querySelector('.js-gallery-counter');

  $($gallery).slick({
    slidesToShow: 1,
  });

  calculateCounter(1);

  $($gallery).on('afterChange', (event, slick, currentSlide) => {
    calculateCounter(currentSlide + 1);
  });

  $('.js-gallery-item').click((event) => {
    const $target = event.target;

    console.log($target, $target.dataset.youtube);

    if ($target.dataset.youtube) {
      const mfp = $.magnificPopup.instance;

      mfp.open({
        type: 'iframe',
        items: {
          src: $target.dataset.youtube,
        },
      });
    }
  });

  function calculateCounter(currentSlide) {
    $counter.innerHTML = `${currentSlide}/${$items.length}`;
  }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/gallery.js